<template>
  <div>
    <component-loading :value="isLoadingAreas" />

    <div>
      <TabelaAreas
        :tableRows="arrayAreas"
        :items="['05', '10', '15']"
        :qtResultados="qtResultados"
        :showCheck="opcaoEditar"
        :qtPaginas="qtPaginas"
        :pagina="pagina"
        :isEdit="isEdit"
        :canEdit="canEdit"
        :elementsPerPageProp="elementsPerPage"
        :ordemProp="ordem"
        ref="table"
        v-if="!isLoadingAreas"
        @clickButton="gerenciaModal"
        @change-page="changePage"
        @elements-per-page-change="changeElements"
        @click="drawer = true"
        @ordem="changeOrdem"
        @anexar="anexar()"
      />
    </div>

    <ModalArea
      :canEdit="canEdit"
      :isEdit="isEdit"
      :isNew="isNew"
      :nomeAcao="acao"
      :value="show"
      :propAreas="propAreas"
      ref="modalArea"
      @input="(input) => changeInput(input)"
      @save-area="(obj) => saveArea(obj)"
      @new-save="(obj) => newSaveArea(obj)"
      @change-id="(id) => (propAreas.id = id)"
    />

    <error-modal v-model="error" :errObj="errObj" />

    <ExcluirModal
      :showDelete="showDelete"
      text="Tem certeza que deseja excluir essa Área?"
      @close="closeDelete"
      @confirmDelete="confirm()"
    />

    <SucessoModal :showSucess="showSucess" :sucessType="type" successName="Área" @close="closeSuccess" />

    <FiltroAreas v-model="drawer" :items="[]" @filtro="(obj) => changeFiltro(obj)" />

    <overlay-loading :value="isLoadingAreasOverlay" />
  </div>
</template>

<script>
import TabelaAreas from './Shared/TabelaAreas'
import ModalArea from './Shared/Area/ModalArea'
import FiltroAreas from './Shared/Area/FiltroAreas'
import Areas from '@/services/Areas/Areas.js'
import { cloneDeep } from 'lodash'

import jwtDecode from 'jwt-decode'

export default {
  components: {
    TabelaAreas,
    ModalArea,
    FiltroAreas
  },
  data() {
    return {
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      canEdit: false,
      isEdit: false,
      acao: '',
      show: false,
      showDelete: false,
      showSucess: false,
      selected: [],
      delSeletected: [],
      type: '',
      propAreas: {},
      arrayAreas: [],
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 1,
      elementsPerPage: '10',
      isLoadingAreas: false,
      drawer: false,
      nomeFiltro: '',
      idAreaFiltro: '',
      ordem: 'asc',
      ordenacao: 'tipoArea.nome',
      isLoadingAreasOverlay: false,
      role: '',
      isNew: false,
      error: false,
      errObj: {
        status: '',
        error: ''
      },
      createNewAgain: false
    }
  },
  async beforeMount() {
    this.role = jwtDecode(localStorage.getItem('tokenBearer')).role
    this.isLoadingAreas = true
    await this.changePagination(this.args)
  },
  methods: {
    closeDelete() {
      this.showDelete = false
      this.delSeletected = []
    },
    anexar() {
      this.showModalAnexo = true
      this.abaRelacionada = 'Áreas'
    },
    async changeInput(input) {
      if (!input) {
        this.show = input
        this.changePagination(this.args)
      } else {
        await this.$nextTick()
        document.documentElement.style.overflow = 'hidden'
        await this.$nextTick()
        this.show = input
      }
    },
    async gerenciaModal(obj) {
      this.isLoadingAreasOverlay = true
      let selected = obj.selected
      const index = obj.index
      switch (obj.type) {
        case 'view':
          this.acao = 'VISUALIZAR'
          this.type = 'view'
          this.selected = selected
          this.isEdit = false
          this.canEdit = false
          this.isNew = false
          this.propAreas = cloneDeep(this.arrayAreas[index])
          // this.propAreas =
          await this.$nextTick()
          await this.$refs.modalArea.start(this.propAreas)
          this.show = true
          break
        case 'edit':
          this.isEdit = true
          this.canEdit = true
          this.isNew = false
          this.acao = 'EDITAR'
          this.type = 'edit'
          this.selected = selected
          this.propAreas = cloneDeep(this.arrayAreas[index])
          await this.$nextTick()
          await this.$refs.modalArea.start(this.propAreas)
          this.show = true
          break
        case 'delete':
          this.type = 'del'
          this.show = false
          this.showDelete = true
          this.delSeletected.push(this.arrayAreas[obj.index].id)
          break
        case 'delAll':
          this.type = 'del'
          this.show = false
          this.showDelete = true
          this.selected = selected
          this.selected.forEach((item) => {
            this.delSeletected.push(item)
          })
          break
        case 'add':
          this.propAreas.id = null
          this.type = 'new'
          this.acao = 'ADICIONAR'
          this.isEdit = false
          this.canEdit = true
          this.isNew = true
          this.disabled = false
          this.selected = []
          await this.$nextTick()
          await this.$refs.modalArea.start()
          break
        default:
          this.show = false
          break
      }
      this.isLoadingAreasOverlay = false
    },
    async confirm() {
      this.$refs.table.cleanSelected()
      this.isLoadingAreas = true
      this.show = false
      this.showDelete = false
      await this.deleteAreas()
      this.showSucess = true
    },
    async closeSuccess() {
      this.showSucess = false
      // await this.changePagination(`?tamanhoPagina=${this.elementsPerPage}&pagina=1`)
      if (this.createNewAgain) {
        this.propAreas.id = null
        this.type = 'new'
        this.acao = 'ADICIONAR'
        this.isEdit = false
        this.canEdit = true
        this.isNew = true
        this.disabled = false
        this.selected = []
        await this.$refs.modalArea.start()
        this.show = true
      }
      this.createNewAgain = false
    },
    async newSaveArea(obj) {
      this.createNewAgain = true
      await this.saveArea(obj)
    },
    async saveArea(obj) {
      this.isLoadingAreasOverlay = true

      const areas = new Areas(localStorage.getItem('tokenBearer'), this.$appConfig.config.API, this.$idUnimed)

      await areas
        .putAreas(obj)
        .then(() => {
          this.showSucess = true
          this.isLoadingAreasOverlay = false
          this.show = false
        })
        .catch((err) => {
          console.error(err)
          this.error = true
          this.show = false
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
          this.isLoadingAreasOverlay = false
        })
    },
    changeOrdem({ ordem, index }) {
      const ordenacoes = {
        0: 'tipoArea.nome',
        1: 'emailArea.endereco',
        2: 'nomeResponsavel',
        3: 'emailResponsavel.endereco'
      }

      switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
          this.ordenacao = ordenacoes[index]
          this.ordem = ordem
          break

        default:
          this.ordenacao = 'tipoArea.nome'
          this.ordem = 'asc'
          break
      }

      this.changePagination(this.args)
    },
    async changeFiltro(filtro) {
      this.nomeFiltro = filtro.nome
      this.idAreaFiltro = filtro.id
      this.isLoadingAreas = true
      this.pagina = 1
      await this.changePagination(this.args)
      this.drawer = false
    },
    async changeElements(value) {
      this.elementsPerPage = value
      this.pagina = 1
      this.isLoadingAreas = true
      await this.changePagination(this.args)
    },
    async changePage(obj) {
      this.pagina = obj.currentPage
      this.currentPage = obj.currentPage
      this.isLoadingAreas = true
      await this.changePagination(this.args)
    },
    async changePagination(args) {
      this.isLoadingAreas = true

      const areas = new Areas(localStorage.getItem('tokenBearer'), this.$appConfig.config.API, this.$idUnimed)

      await areas
        .getAreas(args)
        .then((res) => {
          this.arrayAreas = res.data.conteudo
          this.pagina = res.data.pagina
          this.qtPaginas = res.data.qtPaginas
          this.qtResultados = res.data.qtResultados
        })
        .catch((err) => {
          console.error(err)
          this.show = false
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.isLoadingAreas = false))
    },
    async deleteAreas() {
      const areas = new Areas(localStorage.getItem('tokenBearer'), this.$appConfig.config.API, this.$idUnimed)

      await areas
        .deleteAreas(this.delSeletected)
        .then(() => {
          this.delSeletected = []

          this.changePagination(
            `?tamanhoPagina=${this.elementsPerPage}&pagina=1&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}&tipoAreaId=${this.idAreaFiltro}&nomeResponsavel=${this.nomeFiltro}`
          )
        })
        .catch((err) => {
          console.error(err)
          this.show = false
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    }
  },
  computed: {
    args() {
      return `?tamanhoPagina=${this.elementsPerPage}&pagina=${this.pagina}&ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}&tipoAreaId=${this.idAreaFiltro}&nomeResponsavel=${this.nomeFiltro}`
    },
    roleComputed() {
      return this.role === 'admin_brasil' || 'admin'
    }
  }
}
</script>
